import React, { useState, useEffect } from "react";
import "./ContainCapability.css";
import img1 from "../containassets/img1.png";
import img2 from "../containassets/img2.png";
import img3 from "../containassets/img3.png";
import img4 from "../containassets/img4.png";
import img5 from "../containassets/img5.png";

export default function ContainCapability() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);
    
  const cases = [
    {
      img: img1,
      name: "Application Containerization",
      text: "We containerize applications using industry-standard tools such as Docker, ensuring consistent runtime behavior across all environments.",
    },
    {
      img: img2,
      name: "Container Orchestration",
      text: "Our solutions leverage orchestration platforms like Kubernetes to manage container deployment, scaling, and availability efficiently.",
    },
    {
      img: img3,
      name: "CI/CD Integration",
      text: "We integrate container workflows into CI/CD pipelines for automated builds, testing, and deployments.",
    },
     {
      img: img4,
      name: "Security & Compliance",
      text: "Security controls, vulnerability scanning, and compliance checks are embedded into container images and workflows.",
    },
    {
      img: img5,
      name: "Cloud & Hybrid Deployment",
      text: "Our container solutions are optimized for AWS, Azure, and hybrid environments, enabling seamless portability and scalability.",
    },
  ];

  const maxSlides = Math.max(0, cases.length - cardsToShow);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setCardsToShow(3);
      } else if (window.innerWidth >= 576) {
        setCardsToShow(2);
      } else {
        setCardsToShow(1);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDotClick = (index) => {
    if (index <= maxSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div id="contain-capability" className="outsourcemainclass">
      <h2 className="heading">
        Why Choose BastionEx?
      </h2>
      <p className="subheading">
      Delivering Secure, Compliant, and High-Performance CI Solutions
      </p>

      <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="error" />
            <span>{item.name}</span>
            <p className="text">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(calc(-${(100 / cardsToShow) * currentSlide}% - ${currentSlide * 12}px))`,
            }}
          >
            {cases.map((item, index) => (
              <div
                className="card"
                key={index}
                style={{
                  flex: `0 0 calc(${100 / cardsToShow}% - ${
                    ((cardsToShow - 1) * 12) / cardsToShow
                  }px)`,
                }}
              >
                <img src={item.img} alt="error" />
                <span>{item.name}</span>
                <p className="text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {maxSlides > 0 && (
          <div className="carousel-dots">
            {Array.from({ length: maxSlides + 1 }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}